'use client';

import React from 'react';
import { newCarsProject, newCarsTrack } from '~/constants/eventable';
import {
  browserCookieIdExperiments,
  userIdExperiments
} from '~/constants/srp/experiments';
import AnalyticsProvider from '~/context/common/AnalyticsProvider';
import {
  DeviceContextProvider,
  type OwnProps as DeviceContextProps
} from '~/context/common/DeviceContext';
import ExperimentProvider, {
  type PropsFromServer
} from '~/context/common/ExperimentProvider';
import {
  StaticContextProvider,
  type OwnProps as StaticContextProps
} from '~/context/common/StaticContext';
import {
  UserContextProvider,
  type OwnProps as UserContextProps
} from '~/context/common/UserContext';
import { ModalContextProvider } from '~/context/new-cars/ModalContext';

type OwnProps = React.PropsWithChildren<{
  forDeviceContext: DeviceContextProps;
  forExperimentContext: PropsFromServer;
  forStaticContext: StaticContextProps;
  forUserContext: UserContextProps;
}>;

export default function MakeProviders({
  children,
  forDeviceContext,
  forExperimentContext,
  forStaticContext,
  forUserContext
}: OwnProps) {
  return (
    <StaticContextProvider {...forStaticContext}>
      <DeviceContextProvider {...forDeviceContext}>
        <ExperimentProvider
          {...forExperimentContext}
          browserCookieIdExperiments={browserCookieIdExperiments}
          userIdExperiments={userIdExperiments}
        >
          <UserContextProvider {...forUserContext}>
            <AnalyticsProvider
              projectName={newCarsProject}
              track={newCarsTrack}
            >
              <ModalContextProvider>{children}</ModalContextProvider>
            </AnalyticsProvider>
          </UserContextProvider>
        </ExperimentProvider>
      </DeviceContextProvider>
    </StaticContextProvider>
  );
}
